import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/admin/login');
      return;
    }

    api.post('/auth/session', { session_id: sessionId })
      .then(r => {
        setUser(r.data);
        window.history.replaceState({}, document.title, '/admin');
        navigate('/admin', { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        navigate('/admin/login', { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F7]">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#1C1C19] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#5C5C59] font-display">Anmeldung läuft...</p>
      </div>
    </div>
  );
}
